<template>
  <header
    class="flex justify-center items-center sticky top-0 z-50 backdrop-blur-sm bg-brand-bg/#fff bg-white"
    style="background-color: #fffef4; padding: 10px"
    @mouseleave="setActiveMenu(null)"
  >
    <img class="img-box" @click="jumpHome" text-3xl :src="logo" alt="Liso" />
    <!-- <div class="container px-4 mx-auto">
      <div
        class="flex justify-between items-center h-20 border-b border-gray-200"
      >
        <div class="flex gap-12 items-center">
          <img
            @click="jumpHome"
            style="height: 8vh"
            text-3xl
            :src="logo"
            alt="Liso"
          />
          <nav class="hidden gap-8 items-center font-semibold md:flex">
            <NavItem
              :title="$t('header.homeProjectors')"
              @hover="setActiveMenu('home')"
            />
            <NavItem
              :title="$t('header.portableProjectors')"
              @hover="setActiveMenu('portable')"
            />
            <NavItem
              :title="$t('header.support')"
              @hover="setActiveMenu('support')"
            />
          </nav>
        </div>
        <div class="flex gap-6 items-center">
          <a
            href="#"
            class="flex gap-2 items-center px-4 py-2 text-sm font-semibold text-white rounded-full transition-all bg-brand-red hover:bg-opacity-90"
          >
            <MegaphoneIcon />
            {{ $t("header.promotion") }}
          </a>
          <div class="relative">
            <button
              @click="showLangMenu = !showLangMenu"
              @blur="closeLangMenu"
              class="flex gap-2 items-center text-sm font-semibold"
              aria-label="Select language"
            >
              <img
                :src="
                  'https://flagcdn.com/' + currentLanguageDetails.flag + '.svg'
                "
                width="24"
                :alt="currentLanguageDetails.name + ' flag'"
              />
              {{ currentLanguageDetails.code.toUpperCase() }}
            </button>
            <div
              v-if="showLangMenu"
              @mousedown.prevent
              class="absolute right-0 z-10 py-1 mt-2 w-40 bg-white rounded-md ring-1 ring-black ring-opacity-5 shadow-lg"
            >
              <a
                v-for="lang in languages"
                :key="lang.code"
                href="#"
                @click.prevent="setLanguage(lang.code)"
                :class="[
                  'flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-100',
                  currentLang === lang.code
                    ? 'text-brand-red font-bold'
                    : 'text-gray-700',
                ]"
              >
                <img
                  :src="'https://flagcdn.com/' + lang.flag + '.svg'"
                  width="20"
                  :alt="lang.name + ' flag'"
                />
                <span>{{ lang.name }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <DropdownMenu v-if="activeMenu">
      <div v-if="activeMenu === 'home'" class="text-lg text-center">
        {{ $t("header.dropdownHome") }}
      </div>
      <div v-if="activeMenu === 'portable'" class="text-lg text-center">
        {{ $t("header.dropdownPortable") }}
      </div>
      <div v-if="activeMenu === 'support'" class="text-lg text-center">
        {{ $t("header.dropdownSupport") }}
      </div>
    </DropdownMenu> -->
  </header>
</template>

<script>
import { MegaphoneIcon } from "./icons/";
import DropdownMenu from "./dropdownMenu.vue";
import NavItem from "./navItem.vue";
import logo from "@/assets/logo.png";

export default {
  name: "Header",
  components: {
    NavItem,
    DropdownMenu,
    MegaphoneIcon,
  },
  data() {
    return {
      logo,
      activeMenu: null,
      showLangMenu: false,
      languages: [
        { code: "en", name: "English", flag: "us" },
        { code: "ru", name: "Русский", flag: "ru" },
        { code: "de", name: "Deutsch", flag: "de" },
        { code: "fr", name: "Français", flag: "fr" },
        { code: "es", name: "Español", flag: "es" },
        { code: "it", name: "Italiano", flag: "it" },
        { code: "zh", name: "中文", flag: "cn" },
      ],
    };
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
    currentLanguageDetails() {
      return (
        this.languages.find((l) => l.code === this.currentLang) ||
        this.languages[0]
      );
    },
  },
  methods: {
    jumpHome() {
      this.$router.push("/");
    },
    setLanguage(langCode) {
      this.$i18n.locale = langCode;
      localStorage.setItem("language", langCode);
      this.showLangMenu = false;
    },
    setActiveMenu(menu) {
      this.activeMenu = menu;
    },
    closeLangMenu() {
      this.showLangMenu = false;
    },
  },
};
</script>
<style scoped>
.img-box {
  width: 200px;
}
</style>
